import React, { useContext, useMemo } from 'react';
import { Button, Card } from 'react-bootstrap';
import { Pen, PlusCircle, Trash } from 'react-bootstrap-icons';
import { assetCategoriesOptions, fieldsWithFormulas, getPresetTableHeaders } from '../../../helpers/constants';
import EntityTable from '../../common/EntityTable';
import { LocalizeContext } from 'react-locale-language';
import { Button as ButtonTW } from '../../ui/button';
import { PenIcon, Trash2 } from 'lucide-react';

const Presets = ({
  presets = [],
  variables = [],
  onPresetAddClick,
  onPresetEditClick,
  onPresetDeleteClick,
  readOnlyMode
}) => {
  const { translate, langCode } = useContext(LocalizeContext);
  const presetTableHeaders = useMemo(() => getPresetTableHeaders(translate), [langCode]);

  //have presets for real estate and all others
  return (
    <Card className="mt-3">
      <Card.Header>{translate('presets')}</Card.Header>
      <Card.Body>
        {[
          { title: translate('real_estate'), filterCategories: ['Real Estate'] },
          { title: translate('others'), filterCategories: assetCategoriesOptions.filter(c => c !== 'Real Estate') }
        ].map(({ title, filterCategories }) => (
          <>
            <h6>
              <b>{title}</b>
            </h6>
            <EntityTable
              rowKeyField={'_id'}
              data={presets
                .filter(p => filterCategories.includes(p.assetType))
                .map(p => ({
                  ...p,
                  remainingPayment:
                    p['apartmentType'] === 'Paper Apartment' && p['remainingPayment']
                      ? p['remainingPayment'] === 'gradualPayment'
                        ? 'Gradual Payment'
                        : 'One Final Payment'
                      : ''
                }))}
              evaluationVariables={variables}
              fieldsWithFormulas={fieldsWithFormulas}
              showEvaluatedValues
              headers={presetTableHeaders.filter(
                h => !h.forAssetTypes || filterCategories.some(c => h.forAssetTypes.includes(c))
              )}
              searchQueryKeys={['name']}
              additionalComponents={() =>
                !readOnlyMode && (
                  <Button
                    size="sm"
                    className="text-white"
                    variant="success"
                    onClick={() => onPresetAddClick(filterCategories)}
                  >
                    <PlusCircle className="mr-1" /> {translate('new_presets')} ({title})
                  </Button>
                )
              }
              actionCell={item =>
                !readOnlyMode && (
                  <div className="d-flex align-items-center  gap-2">
                    <ButtonTW
                      variant="ghost"
                      className="p-1 me-0 bg-transparent"
                      onClick={() => onPresetEditClick(item, filterCategories)}
                    >
                      <PenIcon size={8} className="text-info" />
                    </ButtonTW>
                    <ButtonTW
                      variant="ghost"
                      className="p-1 me-0 bg-transparent"
                      onClick={() => {
                        onPresetDeleteClick(item);
                      }}
                    >
                      <Trash2 size={8} className="text-red-500" />
                    </ButtonTW>
                  </div>
                )
              }
            />
          </>
        ))}
      </Card.Body>
    </Card>
  );
};

export default Presets;
